// NBA Team Logo Mapping
export interface TeamLogoInfo {
  name: string;
  abbreviation: string;
  logoUrl: string;
  primaryColor: string;
}

// Fallback logo URLs (using a more reliable source)
const getFallbackLogoUrl = (abbreviation: string): string => {
  return `https://cdn.nba.com/headshots/nba/latest/1040x760/${abbreviation}.png`;
};

export const NBA_TEAMS: Record<string, TeamLogoInfo> = {
  'Atlanta Hawks': {
    name: 'Atlanta Hawks',
    abbreviation: 'ATL',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612737/primary/L/logo.svg',
    primaryColor: '#E03A3E'
  },
  'Boston Celtics': {
    name: 'Boston Celtics',
    abbreviation: 'BOS',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612738/primary/L/logo.svg',
    primaryColor: '#007A33'
  },
  'Brooklyn Nets': {
    name: 'Brooklyn Nets',
    abbreviation: 'BKN',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612751/primary/L/logo.svg',
    primaryColor: '#000000'
  },
  'Charlotte Hornets': {
    name: 'Charlotte Hornets',
    abbreviation: 'CHA',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612766/primary/L/logo.svg',
    primaryColor: '#1D1160'
  },
  'Chicago Bulls': {
    name: 'Chicago Bulls',
    abbreviation: 'CHI',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612741/primary/L/logo.svg',
    primaryColor: '#CE1141'
  },
  'Cleveland Cavaliers': {
    name: 'Cleveland Cavaliers',
    abbreviation: 'CLE',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612739/primary/L/logo.svg',
    primaryColor: '#860038'
  },
  'Dallas Mavericks': {
    name: 'Dallas Mavericks',
    abbreviation: 'DAL',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612742/primary/L/logo.svg',
    primaryColor: '#00538C'
  },
  'Denver Nuggets': {
    name: 'Denver Nuggets',
    abbreviation: 'DEN',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612743/primary/L/logo.svg',
    primaryColor: '#0E2240'
  },
  'Detroit Pistons': {
    name: 'Detroit Pistons',
    abbreviation: 'DET',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612765/primary/L/logo.svg',
    primaryColor: '#C8102E'
  },
  'Golden State Warriors': {
    name: 'Golden State Warriors',
    abbreviation: 'GSW',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612744/primary/L/logo.svg',
    primaryColor: '#1D428A'
  },
  'Houston Rockets': {
    name: 'Houston Rockets',
    abbreviation: 'HOU',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612745/primary/L/logo.svg',
    primaryColor: '#CE1141'
  },
  'Indiana Pacers': {
    name: 'Indiana Pacers',
    abbreviation: 'IND',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612754/primary/L/logo.svg',
    primaryColor: '#002D62'
  },
  'LA Clippers': {
    name: 'LA Clippers',
    abbreviation: 'LAC',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612746/primary/L/logo.svg',
    primaryColor: '#C8102E'
  },
  'Los Angeles Clippers': {
    name: 'Los Angeles Clippers',
    abbreviation: 'LAC',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612746/primary/L/logo.svg',
    primaryColor: '#C8102E'
  },
  'Los Angeles Lakers': {
    name: 'Los Angeles Lakers',
    abbreviation: 'LAL',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612747/primary/L/logo.svg',
    primaryColor: '#552583'
  },
  'Memphis Grizzlies': {
    name: 'Memphis Grizzlies',
    abbreviation: 'MEM',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612763/primary/L/logo.svg',
    primaryColor: '#5D76A9'
  },
  'Miami Heat': {
    name: 'Miami Heat',
    abbreviation: 'MIA',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612748/primary/L/logo.svg',
    primaryColor: '#98002E'
  },
  'Milwaukee Bucks': {
    name: 'Milwaukee Bucks',
    abbreviation: 'MIL',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612749/primary/L/logo.svg',
    primaryColor: '#00471B'
  },
  'Minnesota Timberwolves': {
    name: 'Minnesota Timberwolves',
    abbreviation: 'MIN',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612750/primary/L/logo.svg',
    primaryColor: '#0C2340'
  },
  'New Orleans Pelicans': {
    name: 'New Orleans Pelicans',
    abbreviation: 'NOP',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612740/primary/L/logo.svg',
    primaryColor: '#0C2340'
  },
  'New York Knicks': {
    name: 'New York Knicks',
    abbreviation: 'NYK',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612752/primary/L/logo.svg',
    primaryColor: '#006BB6'
  },
  'Oklahoma City Thunder': {
    name: 'Oklahoma City Thunder',
    abbreviation: 'OKC',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612760/primary/L/logo.svg',
    primaryColor: '#007AC1'
  },
  'Orlando Magic': {
    name: 'Orlando Magic',
    abbreviation: 'ORL',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612753/primary/L/logo.svg',
    primaryColor: '#0077C0'
  },
  'Philadelphia 76ers': {
    name: 'Philadelphia 76ers',
    abbreviation: 'PHI',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612755/primary/L/logo.svg',
    primaryColor: '#006BB6'
  },
  'Phoenix Suns': {
    name: 'Phoenix Suns',
    abbreviation: 'PHX',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612756/primary/L/logo.svg',
    primaryColor: '#1D1160'
  },
  'Portland Trail Blazers': {
    name: 'Portland Trail Blazers',
    abbreviation: 'POR',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612757/primary/L/logo.svg',
    primaryColor: '#E03A3E'
  },
  'Sacramento Kings': {
    name: 'Sacramento Kings',
    abbreviation: 'SAC',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612758/primary/L/logo.svg',
    primaryColor: '#5A2D81'
  },
  'San Antonio Spurs': {
    name: 'San Antonio Spurs',
    abbreviation: 'SAS',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612759/primary/L/logo.svg',
    primaryColor: '#C8102E'
  },
  'Toronto Raptors': {
    name: 'Toronto Raptors',
    abbreviation: 'TOR',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612761/primary/L/logo.svg',
    primaryColor: '#CE1141'
  },
  'Utah Jazz': {
    name: 'Utah Jazz',
    abbreviation: 'UTA',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612762/primary/L/logo.svg',
    primaryColor: '#002B5C'
  },
  'Washington Wizards': {
    name: 'Washington Wizards',
    abbreviation: 'WAS',
    logoUrl: 'https://cdn.nba.com/logos/nba/1610612764/primary/L/logo.svg',
    primaryColor: '#002B5C'
  }
};

// Helper function to get team info by name or abbreviation
export const getTeamInfo = (teamIdentifier: string): TeamLogoInfo | null => {
  const normalizedIdentifier = teamIdentifier.trim();
  
  // First try exact match
  if (NBA_TEAMS[normalizedIdentifier]) {
    return NBA_TEAMS[normalizedIdentifier];
  }
  
  // Try to find by abbreviation
  const teamByAbbr = Object.values(NBA_TEAMS).find(
    team => team.abbreviation.toLowerCase() === normalizedIdentifier.toLowerCase()
  );
  if (teamByAbbr) {
    return teamByAbbr;
  }
  
  // Try partial name match
  const teamByPartial = Object.values(NBA_TEAMS).find(
    team => team.name.toLowerCase().includes(normalizedIdentifier.toLowerCase()) ||
            normalizedIdentifier.toLowerCase().includes(team.name.toLowerCase())
  );
  if (teamByPartial) {
    return teamByPartial;
  }
  
  return null;
};

// Helper function to get team abbreviation
export const getTeamAbbreviation = (teamName: string): string => {
  const teamInfo = getTeamInfo(teamName);
  return teamInfo?.abbreviation || teamName.substring(0, 3).toUpperCase();
};

// Helper function to get team logo URL with fallback
export const getTeamLogoUrl = (teamName: string): string => {
  const teamInfo = getTeamInfo(teamName);
  if (teamInfo) {
    return teamInfo.logoUrl;
  }
  
  // Fallback for unknown teams
  const abbreviation = getTeamAbbreviation(teamName);
  return getFallbackLogoUrl(abbreviation);
};

// Helper function to get team primary color
export const getTeamPrimaryColor = (teamName: string): string => {
  const teamInfo = getTeamInfo(teamName);
  return teamInfo?.primaryColor || '#CC3333';
}; 